export default __webpack_public_path__ + "static/media/personsIcons.9ce65c88.svg";